<script setup lang="ts">
import StatsGraph from '../../components/global/StatsGraph.vue';
import {computed, onMounted, ref} from "vue";
import { useOrderStore } from '../../store/orders';

// Make this global
interface ChartItem {
    date: string;
    primary: number;
    secondary: number;
    tertiary: number;
}

const date = ref(new Date())
const next_date = computed(() => date.value.setMonth(date.value.getMonth() + 1))
const last_date = computed(() => date.value.setMonth(date.value.getMonth() - 1))
const store = useOrderStore()
const is_loading = ref(false)

const next = async () => {
    date.value = new Date(date.value.setMonth(date.value.getMonth() + 1));
    await getData()
}

const  prev = async () => {
    date.value = new Date(date.value.setMonth(date.value.getMonth() - 1));
    await getData()
}

const getData = async () => {
    is_loading.value = true
    await store.getStats(date.value)
    is_loading.value = false
}

onMounted(async () => {
     await getData()
})
</script>

<template>
    <main>
        <div class="date-select-container">
            <button @click="prev">
                <ah-icon name="arrow-left" />
                {{new Date(last_date).toLocaleDateString('en-US', { month: "short", year: 'numeric' })}}
            </button>
            <p>{{new Date(date).toLocaleDateString('en-US', { month: "short", year: 'numeric' })}}</p>
            <button @click="next">
                {{new Date(next_date).toLocaleDateString('en-US', { month: "short", year: 'numeric' })}}
                <ah-icon name="arrow-right" />
            </button>
        </div>

        <StatsGraph
            v-if="store.stats && !is_loading"
            :period="store?.stats?.period"
            :chart_data="store?.stats?.chart_data"
            :labels="store?.stats?.labels"
            :stats="store?.stats?.stats"
        />
    </main>
</template>
